import type { OrganizationSummary, Permission, PortalFeature } from "../api/contract";

// Privileged access is gated on the server-provided `permissions`/`features` arrays,
// NEVER inferred from `role` alone (G-11). These are pure so they're trivially tested.

export function can(org: OrganizationSummary | undefined | null, permission: Permission): boolean {
  return org?.permissions.includes(permission) ?? false;
}

export function hasFeature(org: OrganizationSummary | undefined | null, feature: PortalFeature): boolean {
  return org?.features.includes(feature) ?? false;
}

export function canAny(org: OrganizationSummary | undefined | null, permissions: Permission[]): boolean {
  return permissions.some((permission) => can(org, permission));
}

/** Human-readable role required for a permission — used in permission-denied copy. */
export function roleForPermission(permission: Permission): string {
  // `security.manage` is intentionally NOT owner-only: access policies are an admin
  // capability server-side (packages/contracts `permissionsByRole`), and the denial
  // copy has to name the role that would actually unblock the reader.
  const ownerOnly: Permission[] = [
    "owners.manage",
    "sso.manage",
    "domains.manage",
    "billing.manage",
    "entitlement.claim",
    "org.destroy"
  ];
  return ownerOnly.includes(permission) ? "owner" : "admin";
}
